var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReCognitionPayoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 150",
    style: {
      enableBackground: "new 0 0 200 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#58AAE1;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M174.7,60.9c0,2.7-1,5.2-2.9,7.1s-4.5,3-7.2,2.9c-2.6,0-5.2-1-7-2.9c-3.8-3.9-3.8-10.2,0-14.1 c1.8-1.9,4.3-3,7-2.9c2.7-0.1,5.3,1,7.2,2.9C173.6,55.7,174.7,58.2,174.7,60.9 M174.7,89.1c0,2.7-1,5.2-2.9,7.1s-4.5,3-7.2,2.9 c-2.6,0-5.2-1-7-2.9c-3.8-3.9-3.8-10.2,0-14.1c1.8-1.9,4.3-3,7-2.9c2.7-0.1,5.3,1,7.2,2.9C173.6,83.9,174.7,86.5,174.7,89.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st1",
    d: "M38.6,108.2c-2.5,0.1-4.9-0.9-6.6-2.6c-1.8-1.8-2.9-4.3-2.9-6.9V71.6c0.1-4.6,1.1-9.1,3-13.3 c1.8-4.1,4.4-7.8,7.6-10.9c3.2-3.1,7-5.6,11.2-7.3c4.3-1.8,8.9-2.8,13.6-3c2.6-0.1,5,0.9,6.8,2.8c1.8,1.8,2.9,4.2,3,6.8 c0.1,2.5-1,4.9-2.8,6.7c-1.9,1.8-4.3,2.8-6.9,2.8c-4.3,0-8.4,1.7-11.5,4.7c-1.5,1.5-2.7,3.3-3.5,5.2c-0.9,2.1-1.3,4.3-1.3,6.5v26.8 c-0.1,2.4-1.1,4.6-2.9,6.3C43.5,107.3,41.1,108.2,38.6,108.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st1",
    d: "M111.6,36.9c4.7,0,9.3,1,13.5,2.9c8.5,3.9,15.4,10.7,19.3,19.2c1.9,4.2,3,8.8,2.9,13.4 c0.1,2.4-1,4.6-2.9,6c-2,1.5-4.6,2.2-7.1,2.1H98.2c2.5,5.1,7.7,8.4,13.4,8.4c1.3,0,2.7-0.1,4-0.4c1-0.3,1.9-0.6,2.8-1 c0.8-0.4,1.7-0.7,2.5-1c0.9-0.3,1.9-0.5,2.8-0.4c3.8,0.1,7.2,2.4,8.7,5.8c0.7,1.6,1,3.4,0.7,5.2c-0.3,1.9-1.2,3.7-2.6,5.1 c-2.6,2.1-5.6,3.7-8.8,4.5c-3.4,0.9-6.8,1.3-10.3,1.4c-4.6,0.2-9.3-0.7-13.5-2.6s-8.1-4.5-11.4-7.8s-5.9-7.2-7.8-11.5 s-2.9-9-2.9-13.7c0-4.6,1-9.2,2.9-13.4s4.5-8.1,7.7-11.4c3.3-3.3,7.1-6,11.3-7.9C102.2,37.9,106.9,36.9,111.6,36.9 M125,64.3 c-4-7.5-13.3-10.4-20.8-6.5c0,0-0.1,0-0.1,0.1c-2.5,1.5-4.5,3.8-5.8,6.4H125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReCognitionPayoff);
export default __webpack_public_path__ + "static/media/re-cognition-payoff.1b842b9497e6403fe5c2ea22378a559a.svg";
export { ForwardRef as ReactComponent };